import Component from '../../../shared/component';
import TooltipTrigger from '../../../shared/components/tooltip-trigger';
import ConversationArchiveButton from './conversation-archive-button';

export default class ConversationList extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
  }

  unbindEvents() {
    if (this.archiveButtons) {
      this.archiveButtons.forEach((button) => button.unbindEvents());
    }

    if (this.tooltipTriggers) {
      this.tooltipTriggers.forEach((trigger) => trigger.unbindEvents());
    }
  }

  fetchData() {
    $.get(this.$element.data('action')).done((data) =>
      this.handleSidebarSuccess(data)
    );
  }

  handleSidebarSuccess(data) {
    this.$element.html(data);

    this.archiveButtons = ConversationArchiveButton.initialize(
      this.$element.find('.conversationArchiveButton')
    );
    this.tooltipTriggers = TooltipTrigger.initialize(
      this.$element.find('.tooltipTrigger')
    );
  }
}
